export default "__VITE_ASSET__BEp87cWa__"